import base_mutations from '@/store/modules/base/mutations.js'

export default {
    ...base_mutations,
    set_favourite (state, key_value) {
        let key = key_value.key;
        let value = key_value.value;
        state.favourites[key] = value;
    },
    set_users (state, key_value) {
        let key = key_value.key;
        let value = key_value.value;
        state.users[key] = value;
    }
}
